import React, { useEffect, useRef, useContext } from 'react';
import './ParkAssist.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import Header from '@/v2/components/application/Header';
import TimelineText from '@/v2/components/atoms/TimelineText';
import TimeController from '@/v2/components/controllers/TimeController';
import Fade from '@/v2/components/atoms/Fade';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { DriverAssistContext } from '@/v2/state/providers';

const videoReady = (controller, videoController, onReady) => {
    // eslint-disable-next-line no-param-reassign
    videoController.current = controller;
    onReady();
};

const activate = (setTime, timeline, videoController, timeController, onFinished) => {
    videoController.current.Play();

    // eslint-disable-next-line no-param-reassign
    timeController.current = new TimeController(setTime);
    timeController.current.AddTimeoutFromTimeline(timeline, () => onFinished());
};

export default ({ isActive, data, onFinished, onReady }) => {
    const videoController = useRef(null);
    const timeController = useRef(null);

    const time = useRef(TimelineText.Time());
    const [{ disclaimer }] = useContext(DriverAssistContext);

    useEffect(() => {
        if (isActive) activate(time.current.Set, data.text.timeline, videoController, timeController, onFinished);
    }, [isActive]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, videoController, onReady),
        autoPlay: false,
        loop: false,
        onFinished,
    };

    const disclaimerContent = disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    return (
        <div className="ParkAssist">
            <VideoSimple src={data.video} options={options} />
            <Header show hideLogo dark />
            <TimelineText data={data.text.timeline} time={time.current} background="dark" color="black" />
            <Fade show={!isActive} light cover />
            {disclaimerContent}
        </div>
    );
};
